import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import PageProgress from '../../components/PageProgress'
import Paper from '@material-ui/core/Paper/Paper'
import Colors from '../../assets/styles/colors'

const styles = ({spacing: {unit}}) => ({
  root: {
    maxWidth: 688,
    maxHeight: 680,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: Colors.LightGrey,
    width: '100%',
    height: '100%'
  },
  progress: {
    position: 'absolute',
    zIndex: 9999,
    width: '100%',
    opacity: 0.5
  }
})

export default withStyles(styles, {name: 'PopupBox'})(
  class PopupBox extends React.Component {
    state = {options: {}}

    handleCloseClick = event => {
      const {onClose} = this.props
      onClose && onClose(event)
    }

    render() {
      const {
        children: childrenProp,
        classes,
        className,
        isLoading,
        maxWidth,
        maxHeight
      } = this.props

      const style = {}

      if (maxWidth > 0) {
        style.maxWidth = maxWidth
      }

      if (maxHeight > 0) {
        style.maxHeight = maxHeight
      }

      const children = React.Children.map(childrenProp, child => {
        if (!child) {
          return null
        }

        if (!child.props.onClose) {
          return React.cloneElement(child, {
            onClose: this.handleCloseClick
          })
        }

        return child
      })

      return (
        <Paper
          square
          className={classNames(classes.root, className)}
          style={style}
        >
          <PageProgress visible={isLoading} className={classes.progress} />
          {children}
        </Paper>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/shared/components/popup/PopupBox.js